import { Component, OnInit, Input } from '@angular/core';
import { Form, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { ApiConService } from '../shared/api-con.service';
import { GraphicService } from '../shared/graphic.service';
import { ObjectParam } from '../shared/interface/generic-interface';
import { NgIf } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TextoLinkComponent } from '../shared/componentes/texto-link/texto-link.component';
import { BoxAcoesComponent } from '../box-acoes/box-acoes.component';

@Component({
    selector: 'app-config-confirmacao-entrega',
    templateUrl: './config-confirmacao-entrega.component.html',
    styleUrls: ['./config-confirmacao-entrega.component.css'],
    standalone: true,
    imports: [NgIf, NgbTooltip, FormsModule, ReactiveFormsModule, TextoLinkComponent, BoxAcoesComponent]
})
export class ConfigConfirmacaoEntregaComponent {
  formularioConfigApp: FormGroup;
  @Input() dados;
  contemManterSequenciaEntrega: boolean;
  controlaJornadaMotorista = false;
  loading = false
  chaveDispositivoAcesso = null;
  idRoteiro: number;
  numeroRoteiro: string = '';
  formularioManterSequencia: FormGroup;
  formularioPermitirIniciar: FormGroup

  constructor(
    private fb: FormBuilder,
    private boxListTruckService: BoxListTruckService,
    private apiConService: ApiConService,
    private graphicService: GraphicService
  ) { }

  async ngOnInit() {
    this.numeroRoteiro = this.dados.roteiro;
    this.idRoteiro = this.dados.IdRoteiro;
    this.chaveDispositivoAcesso = this.dados.ChaveDispositivoAcesso;

    let configuracaoApp = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).ConfigRecebimentoApp || "0";
    this.contemManterSequenciaEntrega = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).ManterSequenciaEntrega ?? null;

    let manterSequenciaEntrega = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).ManterSequenciaEntrega == true ? 1 : 0;
    let permitirInicioPrevisao = JSON.parse(this.boxListTruckService.listTruckService.InfoRota)?.PermitirIniciarRoteiroAntesPrevisao
    let permitirIniciarRoteiroAntesPrevisao = permitirInicioPrevisao != null ? permitirInicioPrevisao ? 1 : 0 : 1


    this.formularioConfigApp = this.fb.group({
      config: [configuracaoApp],
    })

    this.formularioManterSequencia = this.fb.group({
      manterSequenciaEntrega: [manterSequenciaEntrega],
    });

    this.formularioPermitirIniciar = this.fb.group({
      permitirIniciarRoteiroAntesPrevisao: [permitirIniciarRoteiroAntesPrevisao],
    });
  }

  async atualizaConfigApp() {
    let config = this.formularioConfigApp.value.config;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    let contemNomeMotorista = this.boxListTruckService.listTruckService.nome_motorista;

    if (contemNomeMotorista) {
      this.boxListTruckService.listTruckService = {
        ...this.boxListTruckService.listTruckService,
        NomeMotorista: this.boxListTruckService.listTruckService.nome_motorista,
        PlacaVeiculo: this.boxListTruckService.listTruckService.cod_veiculo,
        DescricaoVeiculo: this.boxListTruckService.listTruckService.veiculo
      }
    }

    delete infoRota.ConfigRecebimentoApp;
    infoRota = {
      ...infoRota,
      ConfigRecebimentoApp: config.toString()
    }

    let infoRotaString = JSON.stringify(infoRota);
    this.boxListTruckService.listTruckService.InfoRota = infoRotaString;
    let objParam: ObjectParam = {
      roteiro: this.boxListTruckService.listTruckService
    }

    objParam.roteiro.NumeroRoteiro = this.boxListTruckService.listTruckService.roteiro
    await this.apiConService.put('DCroteiros', this.boxListTruckService.roteiroSelecionado.toString(), objParam)

  }

  atualizaManterSequencia() {
    let manterSequenciaEntrega = this.formularioManterSequencia.value.manterSequenciaEntrega;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    delete infoRota.ManterSequenciaEntrega;
    infoRota = {
      ...infoRota,
      ManterSequenciaEntrega: manterSequenciaEntrega
    };

    let objParam: ObjectParam = {
      infoRota: JSON.stringify(infoRota)
    }

    this.apiConService.put('DCroteiros/infoRota', this.boxListTruckService.roteiroSelecionado.toString(), objParam);
  }

  atualizaPermiInicRotAntesPrevisao() {
    let permitirIniciarRoteiroAntesPrevisao = this.formularioPermitirIniciar.value.permitirIniciarRoteiroAntesPrevisao;
    let infoRota = JSON.parse(this.boxListTruckService.listTruckService.InfoRota);

    delete infoRota.PermitirIniciarRoteiroAntesPrevisao;
    infoRota = {
      ...infoRota,
      PermitirIniciarRoteiroAntesPrevisao: permitirIniciarRoteiroAntesPrevisao
    };

    let objParam: ObjectParam = {
      infoRota: JSON.stringify(infoRota)
    }

    this.apiConService.put('DCroteiros/infoRota', this.boxListTruckService.roteiroSelecionado.toString(), objParam);
  }

  async desconectarVeiculo() {
    this.loading = true
    await this.boxListTruckService.desconectarVeiculo(this.idRoteiro);
    this.chaveDispositivoAcesso = null
    this.loading = false;
  }

  fecharModalConfig() {
    this.graphicService.mostraConfiguracaoRoteiro = false;
  }
}
